document.addEventListener("DOMContentLoaded", () => {
  const chapterScrollContainers = document.querySelectorAll('[id^="chapter-"]');

  chapterScrollContainers.forEach((container) => {
    container.style.scrollMarginTop = "40dvh";
  });
});

document.addEventListener("alpine:init", () => {
  Alpine.data("reportChapters", () => ({
    positionTop: 0,
    lastScrollTop: 0,
    chapters: null,
    currentLink: null,
    menuOpen: false,
    chapterButton: null,
    scrollPosition: 0,
    footerTop: null,
    headerBottom: null,
    init() {
      this.chapters = this.$el;
      const navLinks = this.$refs.chapterLinks.querySelectorAll("li");
      this.currentLink = navLinks[0].querySelector("a").getAttribute("href");
      this.chapterButton = this.$refs.chapterButton;

      const pageFooter = document.querySelector(".Footer");
      const headerBlock = document.querySelector(".header-block");
      this.footerTop = pageFooter.offsetTop;
      this.headerBottom = headerBlock.offsetTop + headerBlock.offsetHeight / 2;

      this.checkPosition(true);
      this.chapterButton.addEventListener("click", () =>
        this.toggleChapterMenu()
      );

      document.addEventListener("scroll", () => this.handleScroll());
    },
    checkPosition(onLoad = false) {
      const contentRows = document.querySelectorAll(".Report__Content [id]");
      const windowOffset = window.outerHeight / 2;

      contentRows.forEach((row) => {
        if (typeof row.id === "undefined" || row.id === null || row.id === "") {
          return false;
        }
        const rowTop = pegasus.getElemOffset(row).top,
          rowBottom = pegasus.getElemOffset(row).bottom;

        let st = window.scrollY;

        if (onLoad) {
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        if (st >= this.lastScrollTop) {
          //Scroll Down
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        } else {
          //Scroll Up
          if (
            window.scrollY - windowOffset <= rowBottom &&
            window.scrollY - windowOffset >= rowTop
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        this.lastScrollTop = st;
      });

      if (window.scrollY <= this.positionTop.top) {
        const allLinks = this.$refs.chapterLinks.querySelectorAll("a");

        this.currentLink = allLinks[0].getAttribute("href");
      }
    },
    toggleChapterMenu() {
      this.chapters.classList.toggle("expanded");
    },
    handleScroll() {
      this.scrollPosition = window.scrollY + window.innerHeight;
      if (
        this.scrollPosition <= this.footerTop &&
        window.scrollY >= this.headerBottom
      ) {
        this.chapters.classList.remove("hide");
      } else {
        this.chapters.classList.add("hide");
      }
    },
  }));
});

document.addEventListener("alpine:init", () => {
  Alpine.data("reportChaptersMobile", () => ({
    menuOpen: false,
    isFixed: false,
    navHeight: 0,
    navMenu: null,
    spacer: null,
    currentLink: null,
    init() {
      this.positionTop = pegasus.getElemOffset(this.$el);
      this.currentLink = window.location.href;
      this.navMenu = this.$refs.chapterContainer;
      this.nav = document.querySelector("#page-nav-container");
      this.navHeight = this.nav.clientHeight;
      this.spacer = this.$refs.spacer;
      const navLinks = this.$refs.chapterLinks.querySelectorAll("li");
      this.currentLink = navLinks[0].querySelector("a").getAttribute("href");

      pegasus.onResizeFinished(() => {
        setTimeout(() => {
          this.navHeight = this.nav.clientHeight;

          if (this.navHeight > this.navMenu.clientHeight) {
            this.spacer.style.height = this.navHeight + "px";
            this.navMenu.style.marginTop = this.navHeight + "px";
          } else {
            this.spacer.style.height = this.navMenu.clientHeight + "px";
            this.navMenu.style.removeProperty("margin-top");
          }
        }, 300);
      }, true);

      this.checkPosition(true);
    },
    fix() {
      if (this.isFixed) {
        if (window.scrollY <= this.positionTop.top + this.navHeight) {
          this.isFixed = false;
        }
      } else {
        if (window.scrollY >= this.positionTop.top + this.navHeight) {
          this.isFixed = true;
        }
      }

      this.checkPosition();
    },
    checkPosition(onLoad = false) {
      const contentRows = document.querySelectorAll(".Report__Content [id]");
      const windowOffset = window.outerHeight / 2;

      contentRows.forEach((row) => {
        if (typeof row.id === "undefined" || row.id === null || row.id === "") {
          return false;
        }
        const rowTop = pegasus.getElemOffset(row).top,
          rowBottom = pegasus.getElemOffset(row).bottom;

        let st = window.scrollY;

        if (onLoad) {
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        if (st >= this.lastScrollTop) {
          //Scroll Down
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        } else {
          //Scroll Up
          if (
            window.scrollY - windowOffset <= rowBottom &&
            window.scrollY - windowOffset >= rowTop
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        this.lastScrollTop = st;
      });

      if (window.scrollY <= this.positionTop.top) {
        const allLinks = this.$refs.chapterLinks.querySelectorAll("a");

        this.currentLink = allLinks[0].getAttribute("href");
      }
    },
  }));
});
